__turbopack_context__.v({
  "className": "inter_fb713dd9-module__IJoY3a__className",
  "variable": "inter_fb713dd9-module__IJoY3a__variable",
});
